import { composeWithDevTools } from "@redux-devtools/extension";
import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";
import * as adminActionCreators from "./app/js/admin/ducks/actions";
import * as compActionCreators from "./app/js/comp/ducks/actions";
import * as dealActionCreators from "./app/js/deal/ducks/actions";
import * as listingActionCreators from "./app/js/listing/ducks/actions";
import * as propertyActionCreators from "./app/js/property/ducks/actions";
import * as searchActionCreators from "./app/js/search/ducks/actions";
import config from "./config";
import filterResetMiddleware from "./middleware/filterResetMiddleware";
import rootReducer from "./rootReducer";

const actionCreators = [
    listingActionCreators,
    compActionCreators,
    searchActionCreators,
    adminActionCreators,
    dealActionCreators,
    propertyActionCreators,
];

const composeEnhancers = composeWithDevTools({
    actionCreators,
    trace: true,
    traceLimit: 25,
});

export default function configureStore() {
    return createStore(
        rootReducer,
        config.profile === "local"
            ? composeEnhancers(applyMiddleware(thunk, filterResetMiddleware))
            : composeWithDevTools(applyMiddleware(thunk, filterResetMiddleware))
    );
}
